import { BaseModelState } from "./BaseModel";
import { PlatformInfoDTO } from "./dto/PlatformInfoDTO";

export interface PlatformInfoState extends BaseModelState<PlatformInfoDTO> {}

export const InitialPlatformInfo: PlatformInfoState = {
    dto: {
        visitorsPerDay: 0,
        worksPerDay: 0,
        worksPerHour: 0,
    },
};
